module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_02-fc76c17252f62e62ee96cc085c79935b.jpg";